import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a076c29f6558f00148eb9b3_1786405461148_80746fe8/jsn/src/app/home/components/HomeScreen.tsx");
